module.exports = __webpack_public_path__ + "static/media/space_ufo.71186044.svg";